import { useQuery } from 'react-query';
import { useAuth } from './useAuth';
import api from '../utils/api';

const fetchSession = async (sessionId, user) => {
  if (!sessionId || !user) {
    return null;
  }

  const response = await api.get(`/api/sessions/${sessionId}`);

  return response.data.session;
};

export const useSession = (sessionId, enabled = true) => {
  const { user } = useAuth();

  return useQuery(
    ['session', sessionId],
    () => fetchSession(sessionId, user),
    {
      enabled: enabled && !!sessionId && !!user,
      staleTime: 30 * 1000, // 30 seconds - socket handles freshness now
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchInterval: 30 * 1000, // Safety-net polling every 30 seconds (socket is primary)
      refetchOnWindowFocus: true, // refetch when user returns to tab
      refetchIntervalInBackground: false, // Don't poll in background
      retry: 5,
      retryDelay: (attempt) => Math.min(2000 * attempt, 10000),
      onError: (error) => {
        console.error('Failed to fetch session:', error);
      },
      onSuccess: (data) => {
        console.log('[useSession] Data refreshed:', data?.name || 'No session');
      }
    }
  );
}; 